// extracted by mini-css-extract-plugin
export default {"steep":"HowCard_steep__hdxXG","card":"HowCard_card__ce5Hf","text":"HowCard_text__Z1pRM","title":"HowCard_title__-hQZY"};